import secureLocalStorage from "react-secure-storage";

export const STORAGE_KEYS = {
  token: "TOKEN",
  userData: "USER_DATA",
  credentials: "REMEBER_ME",
  tempToken: "TEMP_TOKEN",
  language: "LANGUAGE",
  fcmToken: "FCM_TOKEN",
};

export function storeData(key: string, value: string) {
  secureLocalStorage.setItem(key, value);
}
export function getData(key: string) {
  return secureLocalStorage.getItem(key);
}
export function clearData() {
  secureLocalStorage.clear();
}

export function removeItem(key: string) {
  secureLocalStorage.removeItem(key);
}
